import { isSocialNetworkInAppWebView } from '~/@lib/utils/function.utils'
import { PhoneVerificationSocialInAppWebView } from '../social-inapp-web-view/PhoneVerificationSocialInAppWebView'
import { PhoneVerification } from './PhoneVerification'
import { HeadingTwo } from '~/@mid_ui/typography/HeadingTwo'
import { Text } from '~/@mid_ui/typography/Text'
import { useUser } from '~/@biz_account/useUser/useUser'
import { PhoneVerificationForm } from '../phone-verification-form/PhoneVerificationForm'
import { useEffect, useState } from 'react'
import { PageContainer } from '~/@mid_ui/page-container/PageContainer'
import { CompanyCompletion } from '../company-completion/CompanyCompletion'

function PhoneVerificationContent() {
  const isWebView = isSocialNetworkInAppWebView()
  const { user } = useUser()
  const showGdprCheckboxes = user?.profile?.gdpr == null
  const [isCompanyCompletionShown, setIsCompanyCompletionShown] =
    useState(false)

  useEffect(() => {
    return () => {
      setIsCompanyCompletionShown(false)
    }
  }, [])

  if (isCompanyCompletionShown) {
    return (
      <PageContainer>
        <CompanyCompletion />
      </PageContainer>
    )
  }

  return (
    <>
      <HeadingTwo className="text-4xl font-bold mb-5">
        Váš e-mail bol zadaný
      </HeadingTwo>
      <Text className="text-md leading-normal">
        Doplňte svoje telefónne číslo, aby sme ho mohli overiť a dokončiť
        registráciu.
      </Text>
      {!isWebView && (
        <PhoneVerification
          handleSetCompanyCompletionShown={() =>
            setIsCompanyCompletionShown(true)
          }>
          {(submitForm, isPending, error) => (
            <PhoneVerificationForm
              showGdprCheckboxes={showGdprCheckboxes}
              handleSubmitForm={submitForm}
              isPending={isPending}
              error={error}
            />
          )}
        </PhoneVerification>
      )}
      {isWebView && (
        <PhoneVerificationSocialInAppWebView>
          {(submitForm, isPending) => (
            <PhoneVerificationForm
              showGdprCheckboxes={showGdprCheckboxes}
              handleSubmitForm={submitForm}
              isPending={isPending}
            />
          )}
        </PhoneVerificationSocialInAppWebView>
      )}
    </>
  )
}

export { PhoneVerificationContent }
